import { render, staticRenderFns } from "./BScroll.vue?vue&type=template&id=a163bba0&scoped=true&"
import script from "./BScroll.vue?vue&type=script&lang=js&"
export * from "./BScroll.vue?vue&type=script&lang=js&"
import style0 from "./BScroll.vue?vue&type=style&index=0&id=a163bba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a163bba0",
  null
  
)

export default component.exports